/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MachineChartData } from '../../models/machine-chart-data';

export interface GetMachineChartData$Params {
  workCenterId: number;
  periodStart?: string;
  periodEnd?: string;
}

export function getMachineChartData(http: HttpClient, rootUrl: string, params: GetMachineChartData$Params, context?: HttpContext): Observable<StrictHttpResponse<MachineChartData>> {
  const rb = new RequestBuilder(rootUrl, getMachineChartData.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.query('periodStart', params.periodStart, {});
    rb.query('periodEnd', params.periodEnd, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MachineChartData>;
    })
  );
}

getMachineChartData.PATH = '/api/v1/WorkCenter/{workCenterId}/GetMachineChartData';
